import React from "react";
import { ListGroup } from "react-bootstrap";
import { AdditionalEmail } from "../../../common/types/additionalEmail";
import { Loader } from "../../general/Loader";
import "./ReceiptEmails.scss";
import { EmptyState } from "../../general/EmptyState/EmptyState";
import { useRemoveReceiptEmail } from "../../../api/user.api";
import { ReceiptsEmailsRow } from "./ReceiptsEmailsRow";

interface ReceiptEmailsProps {
    isLoading: boolean;
    emails: AdditionalEmail[];
}

export const ReceiptEmails: React.FC<ReceiptEmailsProps> = ({
    isLoading,
    emails,
}) => {
    const removeReceiptEmail = useRemoveReceiptEmail();
    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="receipt-emails">
            <ListGroup>
                <ListGroup.Item className="py-2">
                    <small>Email</small>
                </ListGroup.Item>

                {emails.length > 0 &&
                    emails.map((row) => (
                        <ReceiptsEmailsRow
                            key={row.email}
                            value={row}
                            onRemove={() =>
                                removeReceiptEmail.mutateAsync(row.email)
                            }
                        />
                    ))}

                {emails.length === 0 && (
                    <ListGroup.Item>
                        <EmptyState header="No receipts emails"></EmptyState>
                    </ListGroup.Item>
                )}
            </ListGroup>
        </div>
    );
};
